import { render, staticRenderFns } from "./CreateNewVersionDlg.vue?vue&type=template&id=566ff658&"
import script from "./CreateNewVersionDlg.vue?vue&type=script&lang=js&"
export * from "./CreateNewVersionDlg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports